import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, resolveDynamicComponent as _resolveDynamicComponent, withCtx as _withCtx, createVNode as _createVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

import { onBeforeMount } from 'vue'
import { DEFAULT_LOCALE, useI18n } from '@/composables/useI18n'
import Toast from 'primevue/toast'
import { useRoute } from 'vue-router'


export default /*#__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

const { switchLocale } = useI18n()
const route = useRoute()

onBeforeMount(async () => {
  await switchLocale(DEFAULT_LOCALE)
})

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_openBlock(), _createBlock(_resolveDynamicComponent(_unref(route).meta.layout), null, {
      default: _withCtx(() => [
        (_openBlock(), _createBlock(_component_router_view, {
          key: _ctx.$route.fullPath
        }))
      ]),
      _: 1
    })),
    _createVNode(_unref(Toast), { position: "top-right" })
  ], 64))
}
}

})